import React, { useEffect, useState } from 'react';

const ConfirmDialog = ({ title, message, onConfirm, start }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(()=>{
    setShow(start)
  },[start])

  const handleConfirm = () => {
    onConfirm();
    setShow(false);
  };

  return (
    <>
      {show && (
        <div className="modal" tabIndex="-1" role="dialog" style={{ display: 'block' }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{title}</h5>
                <button type="button" className="close" onClick={handleClose}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>{message}</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleClose}>
                  Cancel
                </button>
                <button type="button" className="btn btn-primary" onClick={handleConfirm}>
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {show && <div className="modal-backdrop fade show"></div>}
    </>
  );
};


const InformationBox = (props) => {
  const [show, setShow] = useState(false);

  useEffect(()=>{
    setShow(props.start)
  },[props.start])

  return (
    <>
      {show && (
        <div className="modal" tabIndex="-1" role="dialog" style={{ display: 'block' }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content" style={{width: '700px'}}>
              <div className="modal-header">
                <h5 className="modal-title">{props.title}</h5>
                <button type="button" className="close" onClick={props.handleClose}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {props.children}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-primary" onClick={props.handleClose}>
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {show && <div className="modal-backdrop fade show"></div>}
    </>
  );
};


export {
  InformationBox,
  ConfirmDialog
};